import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, IMAGES } from "./data";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-[0_10px_30px_-20px_rgba(91,34,63,0.35)]" : "bg-transparent"
      }`}
    >
      <div className="container-lh flex items-center justify-between py-4">
        {/* Logo */}
        <button data-testid="logo-link" onClick={() => handleNav("welcome")} className="flex items-center gap-3 group">
          <span className="relative inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 gentle-pulse">
            <img src={IMAGES.logo} alt="Light-Hearted Healing Centre logo" className="w-full h-full object-contain logo-clean" />
          </span>
          <span className="flex flex-col leading-tight text-left whitespace-nowrap">
            <span
              className={`font-display text-lg sm:text-xl font-semibold tracking-tight transition-colors`}
              style={{ color: scrolled ? "var(--lh-wine)" : "var(--lh-butter)", textShadow: scrolled ? "none" : "0 2px 8px rgba(0,0,0,0.45)" }}
            >
              Light-Hearted
            </span>
            <span
              className={`text-[0.58rem] sm:text-[0.62rem] uppercase tracking-[0.2em] transition-colors hidden sm:inline-block`}
              style={{ color: scrolled ? "var(--lh-plum)" : "var(--lh-butter)", opacity: scrolled ? 1 : 0.92, textShadow: scrolled ? "none" : "0 2px 8px rgba(0,0,0,0.4)" }}
            >
              Healing Centre & Expansion School
            </span>
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => handleNav(l.id)}
              className={`relative text-[0.78rem] uppercase tracking-[0.18em] font-medium transition-colors hover:text-[var(--lh-gold)]`}
              style={{ color: scrolled ? "var(--lh-wine)" : "var(--lh-butter)", textShadow: scrolled ? "none" : "0 2px 8px rgba(0,0,0,0.4)" }}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-now"
            onClick={() => handleNav("book")}
            className="btn-primary"
          >
            Book Now
          </button>
        </nav>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden p-2 rounded-full`}
          style={{ color: scrolled ? "var(--lh-wine)" : "var(--lh-butter)" }}
          aria-label="Open menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-[var(--lh-cream)]">
          <div className="container-lh py-4">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}`}
                onClick={() => handleNav(l.id)}
                className="mobile-nav-link w-full text-left"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-nav-book-now"
              onClick={() => handleNav("book")}
              className="btn-primary mt-5 w-full justify-center"
            >
              Book Now
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
